export default {
  FETCH_TOKEN_CUSTOMER_DETAILS: 'LandingPageConstants.FETCH_TOKEN_CUSTOMER_DETAILS',
};
